import { LdEventStatus } from '@app/main/leak-detection/enums/ld-event-status.enum';
import { LdEventInvestigationResult } from '@app/main/leak-detection/enums/ld-event-investigation-result.enum';
import { LdEventRepairStatus } from '@app/main/leak-detection/enums/ld-event-repair-status.enum';
import {
  ldEventInvestigationResultIcon,
  ldEventRepairStatusIcon,
  ldEventStatusBackground,
  ldEventStatusIcon,
} from '@app/main/leak-detection/configs/ld-event-status.config';
import { unknownMarkerIconSrc } from '@app/main/main-content/map/config/unknown-marker-icon';
import { DEFAULT_ICON_BADGE_BACKGROUND } from '@app/shared/components/icon-badge/icon-badge.component';

/**
 * Lookups over the event-status config, each falling back to a safe default so callers never have to
 * handle a missing status themselves.
 */

export function getLdEventStatusIcon(status: LdEventStatus | undefined): string {
  return (status && ldEventStatusIcon[status]) ?? unknownMarkerIconSrc;
}

export function getLdEventInvestigationResultIcon(result: LdEventInvestigationResult | undefined): string {
  return (result && ldEventInvestigationResultIcon[result]) ?? unknownMarkerIconSrc;
}

export function getLdEventRepairStatusIcon(status: LdEventRepairStatus | undefined): string {
  return (status && ldEventRepairStatusIcon[status]) ?? unknownMarkerIconSrc;
}

export function getLdEventStatusBackground(status: LdEventStatus | undefined): string {
  return (status && ldEventStatusBackground[status]) ?? DEFAULT_ICON_BADGE_BACKGROUND;
}
